// Public vendor catalog metadata for the DWG website navigation.
// Slug is human-readable Indonesian for SEO-friendly URLs.
// Each entry maps to a backend `division_id` and (optional) `brand` filter.

export const VENDORS = [
  {
    slug: "mua-dessy-wedding",
    division_id: "div-mua",
    name: "MUA Dessy Wedding",
    tagline: "Makeup & Bridal",
    description:
      "Sentuhan makeup artist berpengalaman untuk pengantin dan keluarga — dari akad hingga resepsi.",
    order: 1,
    featured: true,
    image:
      "https://images.unsplash.com/photo-1522337660859-02fbefca4702?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "aesthetic-decoration",
    division_id: "div-decor",
    name: "Aesthetic Decoration",
    tagline: "Dekorasi",
    description:
      "Desain dekorasi indoor & outdoor bertema estetik untuk suasana acara yang berkesan.",
    order: 2,
    featured: true,
    image:
      "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "project-by-historia",
    division_id: "div-photo",
    name: "Project by Historia",
    tagline: "Foto & Video",
    description:
      "Fotografer & videografer profesional untuk mengabadikan setiap momen berharga dalam frame sinematik.",
    order: 3,
    featured: true,
    image:
      "https://images.unsplash.com/photo-1519225421980-715cb0215aed?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "g-ka-wedding-organizer",
    division_id: "div-wo",
    name: "G-KA Wedding Organizer",
    tagline: "WO Only",
    description:
      "Tim wedding organizer yang fokus pada eksekusi acara — koordinasi vendor, rundown, dan tim on-site.",
    order: 4,
    featured: true,
    image:
      "https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "historia-musical",
    division_id: "div-music",
    name: "Historia Musical",
    tagline: "Musik & Entertainment",
    description:
      "Live music dan entertainment lengkap dengan pilihan format akustik hingga full band.",
    order: 5,
    featured: true,
    image:
      "https://images.unsplash.com/photo-1519676867240-f03562e64548?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "historia-attire",
    division_id: "div-attire",
    name: "Historia Attire",
    tagline: "Attire & Wardrobe",
    description:
      "Koleksi busana pengantin dan keluarga dengan berbagai gaya, tradisional hingga modern.",
    order: 6,
    featured: false,
    image:
      "https://images.unsplash.com/photo-1594736797933-d0501ba2fe65?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "historia-snap",
    division_id: "div-snap",
    name: "Historia Snap",
    tagline: "Same-Day Photo",
    description:
      "Layanan foto instan / same-day edit untuk momen yang langsung bisa dinikmati keluarga.",
    order: 7,
    featured: false,
    image:
      "https://images.unsplash.com/photo-1583939003579-730e3918a45a?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "historias-studio",
    division_id: "div-studio",
    name: "Historia's Studio",
    tagline: "Studio Foto",
    description:
      "Studio foto keluarga, maternity, dan prewedding dengan berbagai konsep dekorasi.",
    order: 8,
    featured: false,
    image:
      "https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "historia-handcraft",
    division_id: "div-handcraft",
    name: "Historia Handcraft",
    tagline: "Souvenir & Handcraft",
    description:
      "Handcraft souvenir & merchandise custom untuk melengkapi hari istimewa.",
    order: 9,
    featured: false,
    image:
      "https://images.unsplash.com/photo-1606216794074-735e91aa2c92?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "wara-wiri-entertainment",
    division_id: "div-warawiri",
    name: "Wara Wiri Entertainment",
    tagline: "MC, Dangdut & Entertainment",
    description:
      "Hiburan lengkap dari MC, band dangdut, DJ, hingga dancer untuk memeriahkan resepsi.",
    order: 10,
    featured: false,
    image:
      "https://images.unsplash.com/photo-1501386761578-eac5c94b800a?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "wedding-effect",
    division_id: "div-effect",
    name: "Wedding Effect",
    tagline: "Special Effect",
    description:
      "Efek panggung cold spark, dry ice, confetti, dan smoke untuk momen dramatis di resepsi.",
    order: 11,
    featured: false,
    image:
      "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "upacara-adat",
    division_id: "div-adat",
    name: "Upacara Adat",
    tagline: "Prosesi Adat",
    description:
      "Koordinator prosesi adat Jawa, Sunda, Batak, Minang, Bali, dan lainnya lengkap dengan perlengkapan.",
    order: 12,
    featured: false,
    image:
      "https://images.unsplash.com/photo-1583939003579-730e3918a45a?auto=format&fit=crop&w=1200&q=80",
  },
];

export const getVendorBySlug = (slug) =>
  VENDORS.find((v) => v.slug === slug) || null;

export const getVendorByDivisionId = (divisionId) =>
  VENDORS.find((v) => v.division_id === divisionId) || null;
